ApplyCancelButtons = require 'components/common/apply_cancel_buttons'
EtdActions = require 'actions/etd_actions'
EtdEditor = require 'components/etd/etd_editor'
Judgement = require 'components/etd/judgements/judgement'
Modal = require 'components/common/modal'
PanelVoiceEtdActions = require 'actions/panel_voice_etd_actions'
PanelVoiceEtdSectionEditModal = require 'components/mixins/panel_voice_etd_section_edit_modal_mixin'
ToggleSwitch = require 'components/common/toggle_switch'
Translation = require 'components/mixins/translation'
{ instanceOf, string, bool } = PropTypes
{ Card, CardContent } = ReactComponents

AssessmentSectionEditModal = createReactClass
  displayName: 'AssessmentSectionEditModal'

  propType:
    criterion: instanceOf(Immutable.Map).isRequired
    researchEvidences: instanceOf(Immutable.Map).isRequired
    additionalConsiderations: instanceOf(Immutable.Map).isRequired
    attachments: instanceOf(Immutable.Map).isRequired
    sectionName: string.isRequired
    criticalOutcomes: instanceOf(Immutable.List).isRequired
    outcomes: instanceOf(Immutable.List).isRequired
    overarchingQuestionData: instanceOf(Immutable.Map)
    sectionId: string.isRequired
    sectionData: instanceOf(Immutable.Map).isRequired
    questionType: string.isRequired
    renderMode: string.isRequired
    highlightToPanelMembers: bool
    templateId: string.isRequired

  getDefaultProps: ->
    overarchingQuestionData: Immutable.Map()

  mixins: [
    Translation('es:recommendations.table')
    PanelVoiceEtdSectionEditModal
  ]

  researchEvidencesEditorRef: (el) ->
    @researchEvidencesEditor = el

  additionalConsiderationsEditorRef: (el) ->
    @additionalConsiderationsEditor = el

  onClose: ->
    PanelVoiceEtdActions.toggleEtdSectionEdit @props.sectionId

  saveChanges: ->
    # save research evidences content
    @researchEvidencesEditor.saveContent()
    # save additional considerations content
    @additionalConsiderationsEditor.saveContent()
    # close modal
    @onClose()

  render: ->
    {
      additionalConsiderations
      attachments
      criterion
      criticalOutcomes
      highlightToPanelMembers
      outcomes
      overarchingQuestionData
      parentSectionsData
      questionType
      researchEvidence
      sectionData
      sectionId
      sectionName
      templateId
    } = @props

    assessmentContainerClass = classNames 'assessment-data',
      highlighted: highlightToPanelMembers

    <Modal
      className='assessment-section-edit-dialog'
      isOpen
      onClose={@onCancel}
      title={@i18n 'editor'}
    >
      <div className='section-details'>
        <span>{sectionName.toUpperCase()}: </span>
        <span>{criterion.get('description')}</span>
      </div>
      <div className='section-data-container'>
        <div id='controls-block'>
          <ToggleSwitch
            label={@i18n 'highlight_for_panel_members'}
            onChange={@toggleSectionHighlight}
            checked={highlightToPanelMembers}
          />
        </div>
        <div className={assessmentContainerClass}>
          <div className='judgement'>
            <h2>{@i18n 'judgements'}</h2>
            <Card>
              <CardContent>
                <Judgement
                  criterion={criterion}
                  criticalOutcomes={criticalOutcomes}
                  editable
                  isRating={sectionData.get('rating', false)}
                  noAutoSave
                  onJudgementChange={@onContentChange}
                  overarchingQuestionData={overarchingQuestionData}
                  parentSectionsData={parentSectionsData}
                  questionType={questionType}
                  sectionData={sectionData}
                  sectionId={sectionId}
                  sectionName={"#{sectionName}-edit-modal"}
                  selectedOption={criterion.get('selectedOption')}
                  templateId={templateId}
                />
              </CardContent>
            </Card>
          </div>
          <div className='research-evidences'>
            <h2>{@i18n 'research_evidence'}</h2>
            <Card className="ep-card-with-etd-editor">
              <CardContent className="ep-card-with-etd-editor__card-content">
                <EtdEditor
                  attachments={attachments}
                  cellId={"#{sectionData.get('researchEvidenceId')}#researchEvidences"}
                  content={researchEvidence.get 'content'}
                  editable
                  noAutoSave
                  onChange={@onContentChange}
                  outcomes={outcomes}
                  onSaveContent={EtdActions.updateEditorContent}
                  onSaveAttachment={EtdActions.saveAttachment}
                  questionType={questionType}
                  ref={@researchEvidencesEditorRef}
                  withApplyCancelButtons={false}
                />
              </CardContent>
            </Card>
          </div>
          <div className='additional-considerations'>
            <h2>{@i18n 'additional_considerations'}</h2>
            <Card className="ep-card-with-etd-editor">
              <CardContent className="ep-card-with-etd-editor__card-content">
                <EtdEditor
                  cellId={"#{sectionData.get('additionalConsiderationId')}#additionalConsiderations"}
                  content={additionalConsiderations.get 'content'}
                  editable
                  noAutoSave
                  noInsertOption
                  onChange={@onContentChange}
                  onSaveContent={EtdActions.updateEditorContent}
                  ref={@additionalConsiderationsEditorRef}
                  withApplyCancelButtons={false}
                />
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
      <ApplyCancelButtons
        onApply={@saveChanges}
        onCancel={@onCancel}
        applyLabel={@i18n '/translation:actions.save'}
        applyClass='btn-send'
      />
    </Modal>

module.exports = AssessmentSectionEditModal
